import React from "react";
import Rmap from "../../assets/rmap.PNG";
import "./roadmap.css";

export const Roadmap = () => {
  return (
    <div className="roadmap__container" id="roadmap">
      <h1 className="roadmap__heading">Roadmap</h1>
      <div className="roadmap__content_container">
        <div className="roadmap__heading_container">
          <div className="roadmap__headings">
            <h1>Q3</h1>
            <h2>2022</h2>
          </div>
          {/* <div className="roadmap__headings">
            <h1>Q4</h1>
            <h2>2022</h2>
          </div> */}
          <div className="roadmap__lists">
            <ul>
              <li>Test Masternode</li>
              <li>Token Deploy</li>
              <li>Multi-swap Offering</li>
              <li>Beta Test Version Development</li>
              <li>Community Marketing</li>
            </ul>
          </div>
          <div className="roadmap__headings">
            <h1>Q1</h1>
            <h2>2023</h2>
          </div>
        </div>
        <img className="roadmap__image" src={Rmap} />
        <div className="roadmap__text_container">
          <div className="roadmap__lists">
            <ul>
              <li>Team Formation</li>
              <li>Website Development</li>
              <li>Website Development</li>
              <li>Product Planning</li>
              <li>Community Initiation</li>
              <li>Partnerships</li>
              <li>Token Generation Initiation</li>
            </ul>
          </div>
          <div className="roadmap__headings">
            <h1>Q4</h1>
            <h2>2022</h2>
          </div>
          {/* <div className="roadmap__lists">
            <ul>
              <li>Test Masternode</li>
              <li>Token Deploy</li>
              <li>Multi-swap Offering</li>
              <li>Beta Test Version Development</li>
              <li>Community Marketing</li>
            </ul>
          </div> */}
          <div className="roadmap__lists">
            <ul>
              <li>Beta Testnet Launch</li>
              <li>Android Application Development</li>
              <li>Main Version Dev</li>
              <li>Scaling Up Masternode</li>
              <li>NFT Marketplace Plan</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
